import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivityInterface } from 'src/app/models/interface/activity.interface';
import { MessageThreadsInterface } from 'src/app/models/interface/message_threads.interface';
import { UserInterface } from '../../../models/interface/user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserSharedService {
  public collaborators$: Observable<UserInterface[]>;
  private collaboratorsSubject = new BehaviorSubject<UserInterface[]>(null);

  public conversations$: Observable<MessageThreadsInterface[] | null>;
  private conversationsSubject = new BehaviorSubject<MessageThreadsInterface[] | null>(null);
  public feedback$: Observable<MessageThreadsInterface[] | null>;
  private feedbackSubject = new BehaviorSubject<MessageThreadsInterface[] | null>(null);
  public tasks$: Observable<ActivityInterface[] | null>;
  private tasksSubject = new BehaviorSubject<ActivityInterface[] | null>(null);

  constructor() {
    this.collaborators$ = this.collaboratorsSubject.asObservable();
    this.conversations$ = this.conversationsSubject.asObservable();
    this.feedback$ = this.feedbackSubject.asObservable();
    this.tasks$ = this.tasksSubject.asObservable();
  }

  pushCollaborators(collaborators: UserInterface[]) {
    if (!Array.isArray(collaborators)) {
      this.collaboratorsSubject.next(null);
    } else {
      this.collaboratorsSubject.next(collaborators);
    }
  }

  pushConversations(conversations: MessageThreadsInterface[] | null) {
    if (!conversations) {
      this.conversationsSubject.next(null);
    } else {
      this.conversationsSubject.next(conversations);
    }
  }

  pushFeedback(feedback: MessageThreadsInterface[] | null) {
    if (!feedback) {
      this.feedbackSubject.next(null);
    } else {
      this.feedbackSubject.next(feedback);
    }
  }

  pushTasks(tasks: ActivityInterface[] | null) {
    if (!tasks) {
      this.tasksSubject.next(null);
    } else {
      this.tasksSubject.next(tasks);
    }
  }
}
